import { FileView } from '../../../api';

export const DEFAULT_DOC_CONTENT_STALE_TIME_IN_MS = 1000 * 60 * 60 * 24; // 24 hours


export const PREVIEWABLE_DOC_TYPES = [
  FileView.file_type.MD,
  FileView.file_type.PDF,
  FileView.file_type.JPEG,
  FileView.file_type.JPG,
  FileView.file_type.PNG,
  FileView.file_type.XLSX
];
